module.exports = __webpack_public_path__ + "static/media/07_plantilla_rec_combo_simple_cp_gaseosas_pet_500_sp.3a66f480.png";